
import { Vue, Prop, Component } from 'vue-property-decorator';
import { SystemListMessage, SystemOption, SystemOptionEvent } from '@/common/bot/types';
import { SystemEvent } from '@/common/bot/enum';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

@Component({
  directives: {
    trackClick,
  },
})
export default class FloatButton extends Vue {
  @Prop({ default: () => ({}) }) readonly categoryMessage!: SystemListMessage;

  readonly BTN_EVTS = BTN_EVTS;

  isOpen = false;

  get categories () {
    return this.categoryMessage?.options || [];
  }

  get borderLine () {
    const remainder = this.categories.length % 3;
    if (remainder === 0) return this.categories.length - 3 - 1;
    const indexNeedLine = this.categories.length - (this.categories.length % 3) - 1;
    return indexNeedLine;
  }

  onSelectCategory (selected: SystemOption) {
    this.$emit('message:input', {
      type: SystemEvent.LIST_OPTION_SELECTED,
      message: this.categoryMessage,
      payload: { selected },
    } as SystemOptionEvent);
    this.toggleMenu();
  }

  toggleMenu () {
    if (!this.categories.length) return;
    this.isOpen = !this.isOpen;
  }
}
